import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Video {
  _id: string;
  isFavourite: boolean;
  isLiked: boolean;
  isDisliked: boolean;
  likesCount: number;
  dislikesCount: number;
  amplifyLikes: number;
  [key: string]: any;
}

interface Serie {
  sectionTitle: string;
  sectionId: string;
  seriesId: string;
  videos: Video[];
}

interface SeriesState {
  series: Serie[];
}

const initialState: SeriesState = {
  series: []
};

const seriesSlice = createSlice({
  name: 'series',
  initialState,
  reducers: {
    setSeries: (state, action: PayloadAction<Serie[]>) => {
      state.series = action.payload;
    },

    toggleVideoFavouriteById: (state, action: PayloadAction<{ videoDocId: string }>) => {
      const { videoDocId } = action.payload;

      for (const serie of state.series) {
        const video = serie.videos.find((v) => v._id === videoDocId);
        if (video) {
          video.isFavourite = !video.isFavourite;
          break;
        }
      }
    },

    toggleLikeVideoById: (state, action: PayloadAction<{ videoDocId: string }>) => {
      const { videoDocId } = action.payload;

      for (const serie of state.series) {
        const video = serie.videos.find((v) => v._id === videoDocId);
        if (video) {
          if (video.isLiked) {
            video.isLiked = false;
            video.likesCount = Math.max(0, video.likesCount - 1);
            video.amplifyLikes = Math.max(0, video.amplifyLikes - 1);
          } else {
            video.isLiked = true;
            video.likesCount += 1;
            video.amplifyLikes += 1;

            if (video.isDisliked) {
              video.isDisliked = false;
              video.dislikesCount = Math.max(0, video.dislikesCount - 1);
            }
          }
          break;
        }
      }
    },

    toggleDislikeVideoById: (state, action: PayloadAction<{ videoDocId: string }>) => {
      const { videoDocId } = action.payload;

      for (const serie of state.series) {
        const video = serie.videos.find((v) => v._id === videoDocId);
        if (video) {
          if (video.isDisliked) {
            video.isDisliked = false;
            video.dislikesCount = Math.max(0, video.dislikesCount - 1);
          } else {
            video.isDisliked = true;
            video.dislikesCount += 1;

            if (video.isLiked) {
              video.isLiked = false;
              video.likesCount = Math.max(0, video.likesCount - 1);
              video.amplifyLikes = Math.max(0, video.amplifyLikes - 1);
            }
          }
          break;
        }
      }
    },

    setVideoWatchedById: (
      state,
      action: PayloadAction<{ videoDocId: string; isWatched: boolean }>
    ) => {
      const { videoDocId, isWatched } = action.payload;
      for (const serie of state.series) {
        const video = serie.videos.find((v) => v._id === videoDocId);
        if (video) {
          video.isWatched = isWatched;
          break;
        }
      }
    }
  }
});

export const {
  setSeries,
  toggleVideoFavouriteById,
  toggleLikeVideoById,
  toggleDislikeVideoById,
  setVideoWatchedById
} = seriesSlice.actions;

export default seriesSlice.reducer;
